import type {LinkedSecurityAlert$key} from '../components/header/__generated__/LinkedSecurityAlert.graphql'
import type {LinkedSecurityAlertsFragment$data} from '../components/header/__generated__/LinkedSecurityAlertsFragment.graphql'

export type LinkedSecurityAlert = {
  key: LinkedSecurityAlert$key
  id: string
}

export type LinkedSecurityAlertsData = {
  fixedAlerts: LinkedSecurityAlert[]
  openAlerts: LinkedSecurityAlert[]
  dismissedAlerts: LinkedSecurityAlert[]
  issueRepositoryName: string
  alerts: LinkedSecurityAlert[]
}

type IssueData = NonNullable<LinkedSecurityAlertsFragment$data>

export const getLinkedSecurityAlerts = (data: IssueData): LinkedSecurityAlertsData => {
  const fixedAlerts: LinkedSecurityAlert[] = []
  const openAlerts: LinkedSecurityAlert[] = []
  const dismissedAlerts: LinkedSecurityAlert[] = []
  const issueRepositoryName = data.repository?.nameWithOwner?.toLocaleLowerCase() ?? ''

  for (const alert of data.securityAlerts?.nodes ?? []) {
    if (!alert || !alert.repository?.nameWithOwner || !alert.number) continue

    const isExternal = alert.repository.nameWithOwner.toLocaleLowerCase() !== issueRepositoryName
    const alertWithId: LinkedSecurityAlert = {
      key: alert,
      id: `${alert.repository.nameWithOwner}/${alert.number}`,
    }

    // We add external alerts to the end of each list
    switch (alert.status) {
      case 'FIXED':
        if (isExternal) {
          fixedAlerts.push(alertWithId)
        } else {
          fixedAlerts.unshift(alertWithId)
        }
        break
      case 'OPEN':
        if (isExternal) {
          openAlerts.push(alertWithId)
        } else {
          openAlerts.unshift(alertWithId)
        }
        break
      case 'DISMISSED':
        if (isExternal) {
          dismissedAlerts.push(alertWithId)
        } else {
          dismissedAlerts.unshift(alertWithId)
        }
        break
      default:
        break
    }
  }

  // Combine all alerts into one list
  const alerts: LinkedSecurityAlert[] = [...fixedAlerts, ...openAlerts, ...dismissedAlerts]
  return {fixedAlerts, openAlerts, dismissedAlerts, issueRepositoryName, alerts}
}
